import React, {useEffect, useState} from "react";
import './search-location-results.scss';
import {
  ClubFinderLocationResultTypes
} from "../../../../../types/ApiTypeDefinition/clubFinderLocationSearchResultTypes";
import locationPin from '../../../../assets/icons/location-pin.svg'
import {useSelector} from 'react-redux';
import {RootState} from '../../../../../store/configureStore';
import {Config} from "../../../../../constants/Config";
import Loader from "../../../Loader/loader";

const baseClass = 'clubFinder-searchLocationResults';
const MobileViewWidth = Config.breakpoints.large.width;

interface PropTypes {
  searchResults: ClubFinderLocationResultTypes[];
  searchStatus: string;
  handleItemSelection?: (data: ClubFinderLocationResultTypes) => void;
  handlePinCodeSuggestedItemSelection?: (data: string) => void;
  isMouseover?: (position: boolean) => void;
  isSearching: boolean;
  pinCodeLocationResults: string[];
  presetValue: string
}

const SearchLocationResults = (props: PropTypes): JSX.Element => {
  const parentWidth = useSelector((state: RootState) => state.widgetConfigurationSettings.widgetParentWidth);
  const tenant = useSelector((state: RootState) => state.widgetConfigurationSettings.tenant);
  const selectedLocation = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedLocation);
  const [calculatedHeightDeduction, setCalculatedHeightDeduction] = useState(0);
  // @ts-ignore
  const defaultSearchLogo = Config.search.defaultLogos[tenant];
  useEffect(() => {
    if (parentWidth <= MobileViewWidth) {
      const searchInputContainer = document.getElementsByClassName('clubFinder-searchLocationInputBox')[0];
      if (searchInputContainer) {
        const bounds = searchInputContainer.getBoundingClientRect();
        const heightDeduction = bounds.height + bounds.top;
        setCalculatedHeightDeduction(heightDeduction);
      }
    }
  }, [parentWidth, calculatedHeightDeduction]);

  useEffect(() => {
    if (props.presetValue && props.searchResults && props.searchResults.length) {
      for (let result of props.searchResults) {
        if (result.placeId) {
          searchItemClickedHandler(result);
          break;
        }
      }
    }
  }, [props.presetValue, props.searchResults]);

  const searchItemClickedHandler = (itemData: ClubFinderLocationResultTypes) => {
    if (props.handleItemSelection) {
      props.handleItemSelection(itemData);
    }
  }

  const searchPinCodeResultItem = (item: string) => {
    if (props.handlePinCodeSuggestedItemSelection) {
      props.handlePinCodeSuggestedItemSelection(item);
    }

  }
  const onMouseOverHandler = (event: React.MouseEvent<HTMLDivElement>): void => {
    if (props.isMouseover) {
      props.isMouseover(true);
    }
  }
  const onMouseOutHandler = (event: React.MouseEvent<HTMLDivElement>): void => {
    if (props.isMouseover) {
      props.isMouseover(false);
    }
  }

  return (
    <div
      className={`${baseClass} ${tenant} ${selectedLocation ? baseClass + "--location-selected" : baseClass + "--location-not-selected"}`}
      onMouseOver={onMouseOverHandler}
      onMouseOut={onMouseOutHandler}
      style={calculatedHeightDeduction > 0 ? {height: `calc(100vh - ${calculatedHeightDeduction}px)`} : {}}
    >
      {props.searchStatus && props.searchStatus.length > 0 && props.isSearching && (
        <div>
          <Loader/>
        </div>
      )}
      {props.searchStatus && props.searchStatus.length > 0 && !props.isSearching && (
        <div>{props.searchStatus}</div>
      )}
      {props.pinCodeLocationResults.map((item: string, index: number) => {
        const logoContainerModifiers = baseClass + '--result-item-logo-container-generic-logo';
        return (
          <div className={`${baseClass}--result-item pinCodeLocation`} key={`search_location_${index}`}
               onClick={() => searchPinCodeResultItem(item)}>
            <div
              className={`${baseClass}--result-item-logo-container ${logoContainerModifiers}`}>
              <img src={locationPin} alt={"location icon"}/>
            </div>
            <div className={`${baseClass}--result-item-details`}>
              <div className={`${baseClass}--result-item-details-title`}>
                {item}
              </div>
            </div>
          </div>
        )
      })}
      {
        props.searchResults.map((item, index) => {
          let clubLogoUrlEnhanced;
          if (item.orgName && item.orgLogo) {
            clubLogoUrlEnhanced = item.orgLogo.replace('h_32', 'h_64');
            clubLogoUrlEnhanced = clubLogoUrlEnhanced.replace('w_32', 'w_64');
          }
          let logoContainerModifiers = '';
          if (item.orgName) {
            logoContainerModifiers = baseClass + '--result-item-logo-container-logo';
          } else {
            logoContainerModifiers = baseClass + '--result-item-logo-container-generic-logo';
          }
          if (!item.orgLogo) {
            logoContainerModifiers = `${logoContainerModifiers} ${baseClass}--result-item-logo-container-default-logo`;
          }
          return (
            <div className={`${baseClass}--result-item`} key={`search_location_${index}`}
                 onClick={() => searchItemClickedHandler(item)}>
              <div
                className={`${baseClass}--result-item-logo-container ${logoContainerModifiers}`}>
                <img src={item.orgName ? item.orgLogo ? clubLogoUrlEnhanced : defaultSearchLogo : locationPin}
                     alt={"location icon"}/>
              </div>
              <div className={`${baseClass}--result-item-details`}>
                <div className={`${baseClass}--result-item-details-title`}>
                  {item.orgName ?
                    item.orgName :
                    item.address.suburb ?
                      (item.address.suburb && item.address.state) ?
                        `${item.address.suburb}, ${item.address.state}` :
                        item.address.suburb :
                      ''}
                </div>
                {item.orgName && (
                  <div className={`${baseClass}--result-item-details-sub-title`}>
                    {item.address.suburb ? item.address.suburb : ''}
                  </div>
                )}

              </div>
            </div>
          )
        })
      }

    </div>
  )
}

export default SearchLocationResults;
